import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, PaymentMethod } from '@stripe/stripe-js';
import CardComponent from 'src/pages/signup/steps/payment/card-component';
import { Coupon } from 'src/pages/deprecated/payment/types';
import colors from 'src/styles/equalution/colors';

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''
);

interface ReactivatePaymentFormProps {
  selectedPlanId: string;
  priceId: string;
  finalPrice: number;
  productId: string;
  coupon?: Coupon;
  handleSubmit: (pm?: PaymentMethod) => void;
  paymentMethod: PaymentMethod | undefined;
  setPaymentMethod: (paymentMethod: PaymentMethod | undefined) => void;
  errorMessage: string;
  setErrorMessage: (msg: string) => void;
  setWalletPaymentIntentId: (id: string) => void;
  noIntentAvailable: boolean;
  setNoIntentAvailable: (val: boolean) => void;
  ctaLabel?: string;
}

export const ReactivatePaymentForm: React.FC<ReactivatePaymentFormProps> = ({
  selectedPlanId,
  priceId,
  finalPrice,
  productId,
  coupon,
  handleSubmit,
  paymentMethod,
  setPaymentMethod,
  errorMessage,
  setErrorMessage,
  setWalletPaymentIntentId,
  noIntentAvailable,
  setNoIntentAvailable,
  ctaLabel,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Stack width="100%" maxWidth="400px" margin="0 auto" alignItems="center">
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 700,
          color: colors.OFF_BLACK,
          textAlign: 'center',
          mb: 2,
        }}>
        Select payment
      </Typography>
      <Box width="100%">
        <Elements stripe={stripePromise}>
          <CardComponent
            selectedPlan={selectedPlanId}
            setPaymentMethod={setPaymentMethod}
            handleSubmit={handleSubmit}
            paymentMethod={paymentMethod}
            priceId={priceId}
            finalPrice={finalPrice}
            planName={selectedPlanId}
            coupon={coupon}
            isChallengeAccepted={false}
            futureCommencement={false}
            tagId={0}
            challengeObject={null}
            productId={productId}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
            setWalletPaymentIntentId={setWalletPaymentIntentId}
            popupVisible={false}
            noIntentAvailable={noIntentAvailable}
            setNoIntentAvailable={setNoIntentAvailable}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isSistemaGiftActive={false}
            isSubmitDisabled={!!errorMessage}
            submitButtonText={ctaLabel ?? 'Reactivate subscription'}
            expiryLabel="Expiry"
          />
        </Elements>
      </Box>
    </Stack>
  );
};
